import './ViewMgtDevice.scss';
import { useAuth } from "context/useAuth";
import { useEffect, useState } from "react";
import { FormLayout } from "layouts/FormLayout/FormLayout";
import { useAppSettings } from "context/appsettingsContext";
import { useCollection } from "functions/hooks/useCollection";
import ViewMgtDeviceStatus from "./Status/ViewMgtDeviceStatus";
import ViewMgtDeviceMainSwitch from "./ViewMgtDeviceMainSwitch";
import { requestDeviceStatus } from "functions/deviceStatusUtils";
import ViewMgtDeviceCommands from "./Commands/ViewMgtDeviceCommands";
import ViewMgtDeviceConfig from "./Configuration/ViewMgtDeviceConfig";
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export default function ViewMgtDevice() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const { deviceId } = useParams();
  const settings = useAppSettings();
  const { authorisedUser } = useAuth();
  const [ device, setDevice ] = useState<any>();
  const [ activeTab, setActiveTab ] = useState('Status');
  const devicesCollection = useCollection<any>('devices');
  
  useEffect(() => {
    document.title = "View Device | Titan Secure";
  }, []);

  useEffect(() => deviceId ? devicesCollection.getOneStream(deviceId, setDevice) : undefined, [
    deviceId, devicesCollection, setDevice
  ]);

  useEffect(() => {
    // GV50 gateways stay reachable through their transport heartbeat. The
    // telemetry stream above updates this view; status commands stay on demand.
    if (!deviceId || deviceId.startsWith("21")) return;

    const intervalId = setInterval(async () => {

      try {
        await requestDeviceStatus(settings.statusRequestCommandUrl, authorisedUser.accessToken, deviceId!)
      } catch(error) {
        console.error('Failed to request status', error);
      }

    }, 60 * 1_000);

    return () => clearInterval(intervalId);

  }, [authorisedUser.accessToken, deviceId, settings.statusRequestCommandUrl]);

  const handleGoBack = () => {
    const params = new URLSearchParams(location.search);
    const map = new Map(params.entries());
    const fromclientid = map.get('fromclientid');
    if (fromclientid && fromclientid != 'undefined' && fromclientid != 'null') {  
      navigate(`/agent/clients/${map.get('fromclientid')}/account/view`);
    } else {
      navigate("/agent/mgt-devices/all");
    }
  };

  return (
    <FormLayout>
      <FormLayout.Header>
        <FormLayout.HeaderBack onClose={handleGoBack} />
        <h2 style={{ fontSize: 'larger' }}>
          Device : {deviceId}
        </h2>
      </FormLayout.Header>

      <FormLayout.Main isNotNarrow={false}>
        <div>
          <ViewMgtDeviceMainSwitch onSwitch={setActiveTab} />
            <div className={`${activeTab === "Status" ? "opacity-100" : "opacity-0 h-0 w-0"}`}>
                <ViewMgtDeviceStatus deviceId={deviceId} device={device} />
            </div>
            <div className={`${activeTab === "Commands" ? "opacity-100" : "opacity-0 h-0 w-0"}`}>
                <ViewMgtDeviceCommands deviceId={deviceId} device={device} />
            </div>
            <div className={`${activeTab === "Configuration" ? "opacity-100" : "opacity-0 h-0 w-0"}`}>
                <ViewMgtDeviceConfig deviceId={deviceId} device={device} />
            </div>
        </div>
      </FormLayout.Main>
    </FormLayout>
  );
}